<template>
  <div>
    <b-card title="Search Assignment Terms" class="b-card-space">
      <p>
        Search and manage assignment terms in Internal Admin.
      </p>
      <a :href="searchUrl">Go to Assignment Terms search</a>
    </b-card>
  </div>
</template>

<script>
import { buildInternalAdminSearchUrl } from '@/helpers/internalAdminLinks'

export default {
  name: 'AssignmentTermsDashboard',
  computed: {
    searchUrl () {
      return buildInternalAdminSearchUrl()
    }
  }
}
</script>

<style scoped>
.b-card-space {
  margin-top: 1rem;
}
</style>
